import PropTypes from 'prop-types'
import clsx from 'clsx'

import {
  TableCell as TableCellMaterial,
  Box,
  Tooltip,
  Typography,
} from '@material-ui/core'

import styles from './styles'

export const DEFAULT_BODY_SKELETON_HEIGHT = 20

const TableCell = ({
  bodySkeletonHeight = DEFAULT_BODY_SKELETON_HEIGHT,
  children,
  overFlowSize = '200px',
  disableTooltip = false,
  noOverFlow = false,
  wrap = false,
  pointer,
  className,
  variant = null,
  color = 'primary',
  ...rest
}) => {
  const useStyles = styles(overFlowSize)

  const classes = useStyles()

  return (
    <TableCellMaterial
      className={clsx({
        [classes.pointer]: pointer,
        [className]: !!className,
      })}
      {...rest}
    >
      {children && (
        <Tooltip
          disableFocusListener={disableTooltip}
          disableHoverListener={disableTooltip}
          disableTouchListener={disableTooltip}
          title={children}
        >
          <Box
            className={
              wrap
                ? classes.wrap
                : noOverFlow
                ? classes.noOverFlow
                : classes.overFlow
            }
          >
            {variant ? (
              <Typography variant={variant} color={color}>
                {children}
              </Typography>
            ) : (
              children
            )}
          </Box>
        </Tooltip>
      )}
    </TableCellMaterial>
  )
}

TableCell.propTypes = {
  bodySkeletonHeight: PropTypes.number,
  overFlowSize: PropTypes.string,
  disableTooltip: PropTypes.bool,
  noOverFlow: PropTypes.bool,
  wrap: PropTypes.bool,
  pointer: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.string,
}

export default TableCell
